import classNames from 'classnames';
import type { PropsWithChildren } from 'react';
import { postCardReadTime } from '../Post.css';

type Props = PropsWithChildren<{
  className?: string;
}>;

const ReadTime = ({ children, className }: Props) => {
  return <p className={classNames(postCardReadTime, className)}>{children}</p>;
};

export default ReadTime;
